export default __webpack_public_path__ + "static/media/how-to-transfer-credit.71e22754.mp4";